import {Component, Input, OnInit} from '@angular/core';
import {isEmpty} from 'lodash';
import {AccountStateLogEntry} from '../api/entity';
import {AccountStateLogService} from '../api/service';

@Component({
    selector: 'tfl-account-state-log',
    template: require('./account.state-log.template.html'),
    providers: [AccountStateLogService]
})
export class AccountStateLogComponent implements OnInit {
    @Input('account-id') accountId: number;

    loading: boolean = false;

    private stateLogEntryList: Array<AccountStateLogEntry> = [];

    constructor(private _accountStateLogService: AccountStateLogService) {
    }

    ngOnInit(): void {
        this.loading = true;
        this._accountStateLogService.getAccountStateLog(this.accountId)
            .subscribe(response => {
                this.stateLogEntryList = response;
                this.loading = false;
            });
    }

    isEmptyLog(): boolean {
        return !this.stateLogEntryList || !this.stateLogEntryList || isEmpty(this.stateLogEntryList);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/account-state-log/account.state-log.component.ts